<template>
  <div style="display: flex; justify-content: space-between; width: 100%;  max-width: 1216px;  margin: 0 23px">
    <div class="menu-button" style="display: flex">
      <p style="margin: auto" >
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="-20 -50 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
          <path d="M4010 4245 c-105 -22 -782 -152 -1066 -205 -276 -52 -316 -63 -351
          -101 -46 -50 -52 -84 -78 -466 -31 -443 -89 -1271 -110 -1549 -20 -274 -20
          -336 5 -383 26 -52 78 -83 139 -83 64 0 105 23 137 77 26 45 27 50 69 653 67
          942 108 1481 115 1491 3 5 201 46 440 91 239 44 482 90 538 101 57 11 105 19
          107 17 8 -8 -18 -495 -27 -521 -14 -36 -20 -39 -319 -150 -419 -156 -570 -218
          -601 -246 -24 -22 -30 -37 -38 -96 -5 -38 -10 -109 -12 -158 -3 -87 -3 -87 22
          -87 22 0 231 77 953 351 114 44 211 79 215 79 19 0 86 67 100 99 11 27 19 143
          34 473 11 241 17 458 14 482 -19 126 -109 167 -286 131z"/>
          <path d="M2000 3864 c-36 -7 -162 -32 -280 -54 -813 -155 -832 -160 -870 -223
          -30 -49 -37 -105 -65 -517 -14 -212 -35 -515 -46 -674 -11 -159 -17 -303 -13
          -320 10 -49 43 -101 77 -122 63 -37 107 -28 652 129 722 208 763 221 791 249
          21 20 26 40 34 114 5 49 10 120 10 157 0 66 -1 68 -22 61 -84 -26 -1174 -334
          -1185 -334 -11 0 -13 10 -9 43 3 23 11 125 17 227 5 102 19 301 29 443 17 244
          20 260 42 284 12 14 37 31 53 38 17 7 161 38 320 69 713 140 679 130 722 196
          29 42 30 109 3 168 -34 75 -116 96 -260 66z"/>
          <path d="M363 3530 c-66 -40 -78 -89 -98 -410 -8 -140 -27 -432 -40 -647 -31
          -482 -31 -553 -5 -611 47 -103 209 -109 270 -10 27 45 37 107 50 298 11 180
          67 1051 74 1167 8 125 -19 188 -91 219 -47 20 -122 18 -160 -6z"/>
          </g>
        </svg>
      </p>
    </div>
    <div style="display: flex;">
      <q-item class="menu-button" style="display: flex; margin:0 4px;" href="https://www.facebook.com/climbicp/" target="_blank">
        <p style="margin: auto" ><font-awesome-icon :icon="['fab', 'facebook-f']" /></p>
      </q-item>
      <q-item class="menu-button" style="display: flex; margin:0 4px;" href="https://www.instagram.com/climbicp" taget="_blank">
        <p style="margin: auto" ><font-awesome-icon :icon="['fab', 'instagram']" /></p>
      </q-item>
      <q-item class="menu-button" style="display: flex; margin:0 4px;" href="https://au.linkedin.com/company/climbicp" taget="_blank">
        <p style="margin: auto" ><font-awesome-icon :icon="['fab', 'linkedin-in']" /></p>
      </q-item>
      <q-item class="menu-button" style="display: flex; margin:0 4px;" href="mailto:info@climbicp.com.au" taget="_blank">
        <p style="margin: auto" ><font-awesome-icon :icon="['far', 'envelope']" /></p>
      </q-item>
    </div>
    <div class="menu-button" style="display: flex" @click="showFullScreenMenu = true">
      <p style="margin: auto" ><font-awesome-icon :icon="['fas', 'bars']" /></p>
    </div>

    <q-dialog
      v-model="showFullScreenMenu"
      persistent
      maximized
      transition-show="fade"
      transition-hide="fade"
    >
      <div class="bg-white text-black" style="width: 100%; height: 100vh">
        <!-- Close Button -->
        <div style="display: flex; width:100%; justify-content: flex-end">
          <div style="margin: 46px 65px 0 0">
            <q-icon name="close" size="lg" v-close-popup class="closeIcon"/>
          </div>
        </div>
        <q-item style="position: absolute; left: 4%; top: 28%;" href="https://climbicp.com" target="_blank">
          <p style="margin: auto" >
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="72" height="72 " viewBox="-20 -50 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
              <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
              <path d="M4010 4245 c-105 -22 -782 -152 -1066 -205 -276 -52 -316 -63 -351
              -101 -46 -50 -52 -84 -78 -466 -31 -443 -89 -1271 -110 -1549 -20 -274 -20
              -336 5 -383 26 -52 78 -83 139 -83 64 0 105 23 137 77 26 45 27 50 69 653 67
              942 108 1481 115 1491 3 5 201 46 440 91 239 44 482 90 538 101 57 11 105 19
              107 17 8 -8 -18 -495 -27 -521 -14 -36 -20 -39 -319 -150 -419 -156 -570 -218
              -601 -246 -24 -22 -30 -37 -38 -96 -5 -38 -10 -109 -12 -158 -3 -87 -3 -87 22
              -87 22 0 231 77 953 351 114 44 211 79 215 79 19 0 86 67 100 99 11 27 19 143
              34 473 11 241 17 458 14 482 -19 126 -109 167 -286 131z"/>
              <path d="M2000 3864 c-36 -7 -162 -32 -280 -54 -813 -155 -832 -160 -870 -223
              -30 -49 -37 -105 -65 -517 -14 -212 -35 -515 -46 -674 -11 -159 -17 -303 -13
              -320 10 -49 43 -101 77 -122 63 -37 107 -28 652 129 722 208 763 221 791 249
              21 20 26 40 34 114 5 49 10 120 10 157 0 66 -1 68 -22 61 -84 -26 -1174 -334
              -1185 -334 -11 0 -13 10 -9 43 3 23 11 125 17 227 5 102 19 301 29 443 17 244
              20 260 42 284 12 14 37 31 53 38 17 7 161 38 320 69 713 140 679 130 722 196
              29 42 30 109 3 168 -34 75 -116 96 -260 66z"/>
              <path d="M363 3530 c-66 -40 -78 -89 -98 -410 -8 -140 -27 -432 -40 -647 -31
              -482 -31 -553 -5 -611 47 -103 209 -109 270 -10 27 45 37 107 50 298 11 180
              67 1051 74 1167 8 125 -19 188 -91 219 -47 20 -122 18 -160 -6z"/>
              </g>
            </svg>
          </p>
        </q-item>
        <!-- Menu -->
        <div style="display: flex; align-items: center; justify-content: center;" class="menuInner" id="menuContent">
          <div>
            <div class="col-2">
              <div style="height: 54px; font-size: 15px; font-weight: 600; color:#c4c5c6">Menu</div>
              <div v-for="(menu,i) in content" :key="i">
                  <TopMenuItem :menuData="menu" class="menuItem"/>
              </div>
              <div style="display: flex; margin: 10px 15px">
                <q-item dense class="mini-menu-button" href="https://www.facebook.com/climbicp/" target="_blank">
                  <p style="margin: auto" ><font-awesome-icon :icon="['fab', 'facebook-f']" /></p>
                </q-item>
                <q-item dense class="mini-menu-button" href="https://www.instagram.com/climbicp" taget="_blank">
                  <p style="margin: auto" ><font-awesome-icon :icon="['fab', 'instagram']" /></p>
                </q-item>
                <q-item dense class="mini-menu-button" href="https://au.linkedin.com/company/climbicp" taget="_blank">
                  <p style="margin: auto" ><font-awesome-icon :icon="['fab', 'linkedin-in']" /></p>
                </q-item>
                <q-item dense class="mini-menu-button" href="mailto:info@climbicp.com.au" taget="_blank">
                  <p style="margin: auto" ><font-awesome-icon :icon="['far', 'envelope']" /></p>
                </q-item>
              </div>
            </div>
          </div>
        </div>

      </div>
    </q-dialog>

  </div>
</template>

<script>

import { ref } from 'vue'
import TopMenuItem from '../components/TopMenuItem';

export default {
  name: 'TopMenuBar',
  components:{
    TopMenuItem
  },
  data () {

    let content = ref([
      {
        menu:"About Us",
        link:"https://climbicp.com/about-us/",
        submenu: [
          {
            sub: "Contact Us",
            link: "https://climbicp.com/contact-us/",
          },
          {
            sub: "Careers",
            link: "https://climbicp.com/au/careers/",
          },
          {
            sub: "Services",
            link: "https://climbicp.com/au/services/",
          },
          {
            sub: "Project Zero",
            link: "https://climbicp.com/au/project-zero/",
          },

        ]
      },
      {
        menu:"Climbing Walls",
        link:"https://climbicp.com/au/climbing-walls/",
        submenu: [
          {
            sub: "Feature Projects",
            link: "https://climbicp.com/feature-projects/",
          },
          {
            sub: "Bouldering Walls",
            link: "https://climbicp.com/au/climbing-walls/boulder-walls/",
          },
          {
            sub: "Rope Walls",
            link: "https://climbicp.com/au/climbing-walls/rope-walls/",
          },
          {
            sub: "Speed Walls",
            link: "https://climbicp.com/au/climbing-walls/speed-walls/",
          },
          {
            sub: "Training Boards",
            link: "https://climbicp.com/au/climbing-walls/training-boards/",
          },
          {
            sub: "ICP Home",
            link: "https://climbicp.com/au/climbing-walls/icp-home-wall/",
          },
          {
            sub: "ICP Play",
            link: "https://climbicp.com/au/climbing-walls/icp-play/",
          }
        ]
      },
      {
        menu:"Climbing Mats",
        link:"https://climbicp.com/au/climbing-mats/",
        submenu: [
          {
            sub: "Bouldering Mats",
            link: "https://climbicp.com/au/climbing-mats/boulder-mats/",
          },
          {
            sub: "Rope Mats",
            link: "https://climbicp.com/au/climbing-mats/rope-mats/",
          }
        ]
      },
      {
        menu:"Climbing Holds",
        link:"https://climbicp.com/au/climbing-holds/",
        submenu: [
          {
            sub: "ICP Raps",
            link: "https://climbicp.com/au/climbing-holds/icp-raps/",
          }
        ]
      },
      {
        menu:"Boulder Hall & Showroom",
        link:"https://climbicp.com/au/icp-fortitudevalley/",
        submenu: [
          {
            sub: "First Visit",
            link: "https://climbicp.com/au/icp-fortitudevalley/first-visit/",
          },
          {
            sub: "Pricing & Memberships",
            link: "https://climbicp.com/au/icp-fortitudevalley/pricing/",
          },
          {
            sub: "Classes & Events",
            link: "https://climbicp.com/au/icp-fortitudevalley/classes-events/",
          },
        ]
      },
      {
        menu:"Route Setting",
        link:"https://climbicp.com/au/route-setting/",
        submenu: [
          {
            sub: "Commercial Setting",
            link: "https://climbicp.com/au/route-setting/commercial/",
          },
          {
            sub: "BoulderCraft Classes",
            link: "https://climbicp.com/au/icp-fortitudevalley/bouldercraft/",
          },
          {
            sub: "Masterclasses",
            link: "https://climbicp.com/au/route-setting/masterclasses/",
          }
        ]
      },
      {
        menu:"Resource Hub",
        link:"https://climbicp.com/category/blog/",
        submenu: []
      },
      {
        menu:"Store",
        link:"https://my.climbicp.com.au/",
        submenu: []
      },
    ])


     let selectedMenu = ref(null)


    return {
      showFullScreenMenu: false,
      menu: false,
      menuOver: false,
      listOver: false,
      content,
      changes:false,
      selectedMenu
    }
  }
}
</script>

<style>
.mini-menu-button {
  background-color: #f2f3f5;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color:#434549;
  font-size: 18px;
  transition: 0.4s;
  display: flex;
  margin:0 4px!important;
  padding: 0!important;
}

.mini-menu-button:hover {
  background-color: #434549;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color:#f2f3f5;
  font-size: 18px;
  transition: 0.4s;
}

</style>
